module.exports = __webpack_public_path__ + "img/huaweilogo_download.9edd2470.png";